import { User } from '../../user/model/user';

// -- 1. Data from Backend ------------------------------------------------------------------------
export const USER_CHANGE_CURRENT = 'USER_CHANGE_CURRENT';
export const BACKEND_VERSION = 'DATA_VERSION';
export const USER_ROLES = 'USER_ROLES';

// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

// -- 1. Data from Backend ------------------------------------------------------------------------
export function userChangeCurrent(user: User) {
  return { type: USER_CHANGE_CURRENT, user: user };
}

export function backendVersion(version: string) {
   return { type: BACKEND_VERSION, payload: {version: version}};
}

export function userRoles(roles: string[]) {
  return { type: USER_ROLES, roles: roles };
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/store/actions.ts